import axios from 'axios';
import { orderBy } from 'lodash';
import { getFunctionUrl, getHostUrl } from '../../../utils';
import { angularService } from './angular.bridge';

const axiosInstance = axios.create({});

function getToken() {
  const key = Object.keys(sessionStorage).find(el => el.includes('oidc.user'));
  const session = key && sessionStorage.getItem(key);
  if (!session) {
    return '';
  }

  const token = JSON.parse(session);
  return `${token.token_type} ${token.access_token}`
}

function getFileNameFromHttpResponse(httpResponse) {
  var contentDispositionHeader = httpResponse.headers["content-disposition"];
  var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
  return result.replace(/"/g, '');
}

export const saveCreateFunction = async (url, stateObject) => {
  return axiosInstance.post(url, { ...stateObject, Metadata: '' }, { headers: { 'Authorization': getToken() } });
};

export const listFunctionsRuntimes = async () => {
  try {
    return axiosInstance.get(`${getFunctionUrl()}/getRuntimes`, { headers: { 'Authorization': getToken() } }).then(res => res.data || []);
  } catch (error) {
    console.error(error);
  }
}

export const listFunctions = async (url: string) => {
  try {
    return axiosInstance.get(url, { headers: { 'Authorization': getToken() } });
  }
  catch (error) {
    console.error(error);
  }
};

export const listFunctionsMethods = async (moduleName: string) => {
  try {
    return axiosInstance.get(`${getFunctionUrl()}/getMetadata`, {
      params: { functionName: moduleName },
      headers: { 'Authorization': getToken() }
    }).then(res => orderBy(res?.data?.MethodSignatures || [], item => item.Signature.toLowerCase()));
  } catch (error) {
    console.error(error);
  }
}

export const invokeFunction = async (data: {module: string, script?: string, method?: string, input: any }) => {
  return await axiosInstance.post(
    `${getHostUrl()}/api/functions/invoke`,
    data,
    { headers: { 'Authorization': getToken() } }
  )
    .then(res => res.data || {})
    .catch(res => {

      const errorRes = JSON.stringify(res, function(key, value) {
        if (typeof value === 'function') {
          return value.toString();
        } else {
          return value;
        }
      });

      return {
        Error: true,
        Output: {
          data: res.response.data.data,
          details: res.response.data.details,
          error: res.response.data.error,
          ...JSON.parse(errorRes)
        }
      }
    })
}

export const importFunction = async (url, file) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append('file', file);

    return axiosInstance.post(url + 'import/xml', bodyFormData, { headers: { 'Authorization': getToken(), 'Content-Type': 'multipart/form-data', } });
  }
  catch (error) {
    console.error(error);
  }
};

export const deleteFunction = async (url) => {
  // try {
    return axiosInstance.delete(url, { headers: { 'Authorization': getToken() } });
  // }
  // catch (error) {
  //   console.error(error);
  // }
};

export const exportFunction = async (url) => {
  try {
    var response = await axiosInstance.get(url + '/xml', { responseType: 'arraybuffer', headers: { 'Authorization': getToken() } });
    var tempUrl = window.URL.createObjectURL(new Blob([response.data]));

    var a = window.document.createElement('a');
    a.setAttribute("type", "hidden");
    a.href = tempUrl;
    a.download = getFileNameFromHttpResponse(response);

    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
    window.URL.revokeObjectURL(tempUrl);
  }
  catch (error) {
    console.error(error);
  }
};

export const installNpmPackagesApi = async (url, stateObject) => {
  return await axiosInstance.post(
    url + 'bundle',
    stateObject,
    { headers: { 'Authorization': getToken() } }
  );
};

export function initRequestProgressBar() {
  let requestsCounter = 0;
  let prgs: any = angularService('cfpLoadingBar');

  const setupStartProgress = () => {
    axiosInstance.interceptors.request.use(config => {
      requestsCounter++;
      prgs.start();
      return config;
    });
  };

  const setupStopProgress = () => {
    const responseFunc = response => {
      if ((--requestsCounter) === 0) {
        prgs.complete();
      }
      return response;
    };

    const errorFunc = error => {
      if ((--requestsCounter) === 0) {
        prgs.complete();
      }
      return Promise.reject(error);
    };

    axiosInstance.interceptors.response.use(responseFunc, errorFunc);
  };

  setupStartProgress();
  setupStopProgress();
}
